import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "classNames"];
import { cx } from "../../lib/cx.js";
export function createAutocompleteComponent(_ref) {
  var createElement = _ref.createElement;
  return function Autocomplete(userProps) {
    var children = userProps.children,
      _userProps$classNames = userProps.classNames,
      classNames = _userProps$classNames === void 0 ? {} : _userProps$classNames,
      props = _objectWithoutProperties(userProps, _excluded);
    return createElement("div", _extends({
      className: cx('ais-Autocomplete', classNames.root)
    }, props), children);
  };
}